export const required = v => !!v || 'This field is required.'

export const valid_password = v => v.length >= 8 || 'Password too short!'

export const valid_us_phone = v => !v || /^\(\d{3}\) \d{3}-\d{4}$/.test(v) || 'Invalid phone number'

export const valid_us_zipcode = v => !v || /^\d{5}$/.test(v) || 'Invalid Zipcode'

export const matches = (f,n) => v => v == f || `Must match ${n}.`

export const valid_code = v => v.length == 6 || 'Code too short!'

export const valid_email = v => !v || /^\w+([.-]?\w+)*([+]\w+)?@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Invalid email address'

export default { 
  matches, required, valid_code, valid_email, valid_password, 
  valid_us_phone, valid_us_zipcode 
}